export const getRouteWithPagination = (baseRoute: string, page?: number, pageSize?: number): string => {
  const queryParams: string[] = []

  if (page) {
    queryParams.push(`page=${page}`)
  }

  if (pageSize) {
    queryParams.push(`pageSize=${pageSize}`)
  }

  return queryParams.length ? `${baseRoute}?${queryParams.join('&')}` : baseRoute
}
